<template>

  <div class="container-fluid container-md p-0 d-flex flex-column vh-100">
    <div class="p-2 d-flex top-0 bg-white flex-wrap border">
      <div class="pe-2 d-flex align-items-center">
        <label class="pe-2">{{currentPage}} / {{totalPages}}</label>
        <button type="button" class="btn" v-bind:disabled="!hasPrev" v-on:click="onPrevClick">前へ</button>
        <button type="button" class="btn" v-bind:disabled="!hasNext" v-on:click="onNextClick">次へ</button>
      </div>
      <div class="pe-2 d-flex align-items-center">
        <button type="button" class="btn" v-on:click="onZoomIn">+</button>
        <button type="button" class="btn" v-on:click="onZoomOut">-</button>
      </div>
      <div class="d-flex">
        <input class="text-end border rounded-3" type="text" v-model.number="zoom" />
      </div>
      <div class="btn-group" role="group">
        <input type="radio" class="btn-check" :name="'operation_mode_'+idPrefix"
               :id="'operation_mode_cursor_'+idPrefix" value="cursor" v-model="cursorMode" />
        <label class="btn" :for="'operation_mode_cursor_'+idPrefix">
          <svgicon name="cursor" />
        </label>
        <input type="radio" class="btn-check" :name="'operation_mode_'+idPrefix"
               :id="'operation_mode_handindex_'+idPrefix" value="hand" v-model="cursorMode" />
        <label class="btn" :for="'operation_mode_handindex_'+idPrefix">
          <svgicon name="hand_index" />
        </label>
      </div>
      <div class="pe-2 d-flex align-items-center">
        <button type="button" class="btn" v-on:click="onDownloadClick">ダウンロード</button>
      </div>
      <div class="w-100">
        <input type="range" step="1" v-model.number="currentPage" min="1" :max="totalPages"
               class="w-100" />
      </div>
    </div>
    <section class="pdf_viewer_container flex-grow-1 border border-top-0 position-relative"
             ref="scrollContainer">
      <viewer ref="viewer"
              :pages="currentPage"
              :scrollContainer="this.$refs.scrollContainer"
              :cursorMode="cursorMode"
              v-bind:url="src"
              v-bind:fileName="'サンプル.pdf'"
              v-bind:workerSrc="workerSrc"
              v-bind:zoom="zoom"
              v-bind:onCurrentPageChange="onCurrentPageChange"
              v-bind:onTotalPagesChange="onTotalPagesChange"
              class="bg-light border-0"></viewer>
    </section>
  </div>

</template>

<style scoped>

  .pdf_viewer_container {
    overflow-y: scroll;
  }

</style>
<script>
  import { defineComponent } from "vue";
  import viewer from "components/pdf_viewer/viewer";

  export default defineComponent({
    props: {
      src: {
        type: String,
        required: true,
      },
      workerSrc: {
        type: String,
      },
      idPrefix: {
        type: String,
        default: null,
      },
    },
    computed: {
      hasPrev: function () {
        return this.currentPage > 1;
      },
      hasNext: function () {
        return this.currentPage < this.totalPages;
      }
    },
    data: () => {
      return {
        currentPage: 1,
        totalPages: 0,
        zoom: 100,
        cursorMode: "cursor",
      }
    },
    methods: {
      onDownloadClick: function (e) {
        this.$refs.viewer.download();
      },
      onCurrentPageChange: function (currentPage) {
        this.currentPage = currentPage;
      },
      onTotalPagesChange: function (totalPages) {
        this.totalPages = totalPages;
      },
      onPrevClick: function (e) {
        if (this.currentPage <= 1) return;
        this.$refs.viewer.setPage(this.currentPage - 1);
      },
      onNextClick: function (e) {
        if (this.currentPage >= this.totalPages) return;
        this.$refs.viewer.setPage(this.currentPage + 1);
      },
      onZoomIn: function () {
        let zoom = this.zoom + 10;
        if (zoom > 400) zoom = 400;
        this.zoom = zoom;
      },
      onZoomOut: function () {
        let zoom = this.zoom - 10;
        if (zoom < 20) zoom = 20;
        this.zoom = zoom;
      },
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
    },
    emits: ["start", "completed"],
    components: {
      "viewer": viewer,
    },
    watch: {
      zoom: function (newVal, oldVal) {
        if (newVal != oldVal) {
          if (Number.isFinite(newVal) === false) {
            this.zoom = 100;
            return;
          }
          if (newVal < 0) {
            this.zoom = 0;
          } else if (newVal > 400) {
            this.zoom = 400;
          }
        }
      },
    }
  });

</script>
